import React, {Component} from 'react'
import {Input} from 'Components/Form'
import {gql} from 'graphql.macro'
import {Query, Mutation} from 'react-apollo'
import {GET_COMPANIES, GET_GROUPS_BY_COMPANY, GET_ME} from './queries'
import {route} from 'router'
import Loading from 'Components/Loading'
// import {connect} from 'react-redux'

import './AddGroup.scss'

const ADD_GROUP = gql`
  mutation ADD_GROUP($name: String, $companyID: Int) {
    addGroup(name: $name, companyID: $companyID) {
      group {
        id
        name
        company {
          id
        }
      }
      error
    }
  }
`

// const mapStateToProps = (state) => ({
//   refetchGroupsByCompany: state.directory.refetchGroupsByCompany
// })

export default class AddMember extends Component {
  state = {
    name: '',
    companyID: 0,
    error: null
  }
  render() {
    return (
      <Query query={GET_ME}>
        {({data, loading, error}) => {
          if (loading) return <Loading />
          if (error) return <div>error</div>
          const me = data.me
          const isSpecificUser = me?.id === 12034 || me?.id === 11394
          return (
            <div className="add-user">
              <div className="container">
                <div className="col person">
                  <div className="row">
                    <span className="fa-stack">
                      <i className="fa fa-circle fa-stack-2x"></i>
                      <i className="fa fa-users fa-stack-1x fa-inverse"></i>
                    </span>
                  </div>
                  <div className="row">
                    <p>
                      New groups will include no users or devices upon creation.
                    </p>
                    {this.state.error && (
                      <p className="error">{this.state.error}</p>
                    )}
                  </div>
                </div>
                <div className="col inputs">
                  <div className="flex-row first-name">
                    <div className="label">Group Name: </div>
                    <div className="input">
                      <input
                        value={this.state.firstName}
                        onChange={(e) => this.setState({name: e.target.value})}
                      />
                    </div>
                  </div>
                  {((data && data.me && data.me.isSuperUser) || isSpecificUser)  && (
                    <Query query={GET_COMPANIES}>
                      {({loading, error, data}) => (
                        <div className="flex-row first-name">
                          <div className="label">Company: </div>
                          <div className="input">
                            <Input
                              type="select"
                              fieldOnly
                              value={this.state.companyID}
                              onChange={(e) =>
                                this.setState({
                                  companyID: e.target.value
                                })
                              }
                              options={[].concat([{label: '', value: 0}]).concat((
                                (data && data.companies) ||
                                []
                              ).filter((c) => {
                                if (me?.id === 12034) {
                                  return [10344, 10303, 10359, 10337, 10345, 10379, 10292, 10381, 10365, 10228, 10384, 10392, 10370, 10338, 10295, 10285, 10339, 10299, 10234, 10396].includes(c.id)
                                } else if (me?.id === 11394){
                                  return [10344, 10345, 10379, 10337, 10381, 10285].includes(c.id)
                                } else {
                                  return true
                                }
                              }).map((c) => ({value: c.id, label: c.name})))}
                            />
                          </div>
                        </div>
                      )}
                    </Query>
                  )}
                  <div className="row buttons">
                    <Mutation mutation={ADD_GROUP}>
                      {(addGroup) => (
                        <button
                          className="primary"
                          disabled={!this.state.name.length}
                          id="add-team-member-button"
                          onClick={async () => {
                            this.setState({error: null})
                            const res = await addGroup({
                              variables: {
                                name: this.state.name,
                                companyID: this.state.companyID
                              },
                              refetchQueries: [
                                {
                                  query: GET_GROUPS_BY_COMPANY,
                                  variables: {
                                    companyID: (me.isSuperUser || isSpecificUser)
                                      ? this.state.companyID
                                      : me.company.id
                                  }
                                }
                              ]
                            })
                            const error =
                              res &&
                              res.data &&
                              res.data.addGroup &&
                              res.data.addGroup.error
                            const groupID =
                              res &&
                              res.data &&
                              res.data.addGroup &&
                              res.data.addGroup.group &&
                              res.data.addGroup.group.id
                            this.setState({error: error})
                            if (!error && groupID)
                              route(`/team/group/${groupID}`)
                          }}
                        >
                          Add Group
                        </button>
                      )}
                    </Mutation>
                  </div>
                </div>
              </div>
            </div>
          )
        }}
      </Query>
    )
  }
}
